import { WarrantyItem } from "./warranty-item";

export enum PlanStatus {
  ACTIVE = "Active",
  Expired = "Expired",
  CANCELLED = "Cancelled",
  CancelDealerReview = "Cancel by Dealer",
  CancelCustomerReview = "Cancel by Customer",
}

export enum PlanTypes {
  ACE = "Ace",
  MACE = "Mace",
  FPP = "FPP",
  LEGACY = "LEGACY",
  UNKNOWN = "UNKNOWN",
}

export interface CorePlan {
  id: number;
  aceMigrated: number;
  programName: string;
  number: string;
  dealerId: string;
  programId: string;
  servicePlanType?: string;
  purchaseDate: Date;
  deliveryDate: Date;
  expirationDate: Date;
  store: string;
  invoiceId: string;
  totalPrice: number;
  warrantyProgramPrice: number;
  planStatus: PlanStatus;
}

export interface FppPlan extends CorePlan {
  customerName: string;
  customerId: string;
  warrantyItems: WarrantyItem[];
  planType: PlanTypes.FPP;
  internallyGenerated?: boolean;
}

//date 26 auguest
export interface AcePlan extends CorePlan {
  customerName: string;
  customerId: string;
  warrantyItems: WarrantyItem[];
  planType: PlanTypes.ACE;
  internallyGenerated?: boolean;
}

export interface LegacyPlan extends CorePlan {
  customerName: string;
  customerId: string;
  warrantyItems: WarrantyItem[];
  planType: PlanTypes.LEGACY;
  internallyGenerated?: boolean;
}

export interface MacePlan extends CorePlan {
  planType: PlanTypes.MACE;
  contractNumber: string;
  dlrRpt: string;
}

export type AllPlans = FppPlan | MacePlan | AcePlan | LegacyPlan;
